export const setUserGeren = (user = '') => {
    localStorage.setItem('authusuariogeren', JSON.stringify(user));    
}

export const getUserGeren = () => {
    return JSON.parse(localStorage.getItem('authusuariogeren'));
}

export const removeUserGeren = () => {
    localStorage.removeItem('authusuariogeren');
}